import React from 'react';
import { Button, Form, Modal, Spinner } from 'react-bootstrap';
import { ErrorMessage, Formik } from 'formik';
import * as Yup from 'yup';

export function AddFAQ({show, handleClose, addNewFAQ}) {
    const validationSchema = Yup.object().shape({
        question: Yup.string().required('Required'),
        answer: Yup.string().required('Required'),
    });

    return (
        <>
            <div className='d-flex justify-content-end mb-3'>
                <Button variant="primary" size={'sm'} onClick={handleClose}>
                    Add FAQ
                </Button>
            </div>

            <Modal show={show} size="lg" onHide={handleClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Add New FAQ</Modal.Title>
                </Modal.Header>
                <Formik
                    initialValues={{
                        question: '',
                        answer: ''
                    }}
                    validationSchema={validationSchema}
                    onSubmit={(values, {setSubmitting}) => addNewFAQ(values, setSubmitting)}>
                    {({
                        values,
                        handleChange,
                        handleSubmit,
                        isSubmitting
                    }) => (
                        <Form onSubmit={handleSubmit}>
                            <Modal.Body>
                                <Form.Group className="mb-3">
                                    <Form.Label>Question</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="question"
                                        placeholder="Type Question Here..."
                                        value={values.question}
                                        onChange={handleChange}
                                        disabled={isSubmitting}
                                    />
                                    <ErrorMessage name='question' component='p' className='error-message' />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label>Answer</Form.Label>
                                    <Form.Control 
                                        as="textarea"
                                        name="answer" 
                                        placeholder="Type answer here..." 
                                        rows={3}
                                        value={values.answer}
                                        onChange={handleChange}
                                        disabled={isSubmitting}
                                    />
                                    <ErrorMessage name='answer' component='p' className='error-message' />
                                </Form.Group>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" size="sm" onClick={handleClose} disabled={isSubmitting}>
                                    Close
                                </Button>
                                <Button variant="primary" size="sm" type="submit" disabled={isSubmitting}>
                                    Save FAQ 
                                    {
                                        isSubmitting &&
                                        <Spinner
                                            as="span"
                                            animation="border"
                                            size="sm"
                                            role="status"
                                            aria-hidden="true"
                                            className='ms-2'
                                        />
                                    }
                                </Button>
                            </Modal.Footer>
                        </Form>
                    )}
                </Formik>
            </Modal>
        </>
    );
}
